<template>
  <v-menu offset-y left>
    <template slot="activator">
      <slot>
      </slot>
    </template>
    <v-list>
      <v-list-tile v-for="(estado, index) in estados" :key="index" @click="changeStatus(estado)">
        <v-list-tile-title>{{ estado.text }}</v-list-tile-title>
      </v-list-tile>
    </v-list>
  </v-menu>
</template>
<script>
export default {

  props: {
    item: Object,
    estados: Array
  },
  methods: {
    changeStatus (estado) {
      this.$emit('changeStatus', estado.value)
    }
  }

}
</script>
